import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper, { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import siteMessage, { siteMessageWithCustomParserOptions } from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import validatePassword from "@insite/client-framework/Store/CommonHandlers/ValidatePassword";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import signIn from "@insite/client-framework/Store/Context/Handlers/SignIn";
import { getCreateAccountReturnUrl } from "@insite/client-framework/Store/Pages/CreateAccount/CreateAccountSelectors";
import translate from "@insite/client-framework/Translate";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Checkbox from "@insite/mobius/Checkbox";
import CheckboxGroup from "@insite/mobius/CheckboxGroup";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { IconPresentationProps } from "@insite/mobius/Icon";
import AlertCircle from "@insite/mobius/Icons/AlertCircle";
import AlertTriangle from "@insite/mobius/Icons/AlertTriangle";
import Eye from "@insite/mobius/Icons/Eye";
import EyeOff from "@insite/mobius/Icons/EyeOff";
import Link from "@insite/mobius/Link";
import LoadingOverlay from "@insite/mobius/LoadingOverlay";
import Select, { SelectPresentationProps } from "@insite/mobius/Select";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import Tooltip, { TooltipPresentationProps } from "@insite/mobius/Tooltip";
import Typography, { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { DepartmentModel } from "@tCooneyBrothers/ApiModels";
import { formatPhoneNumber } from "@tCooneyBrothers/Common/Utilities/formatPhoneNumber";

import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

import React, { RefObject, useEffect, useRef, useState } from "react";

import { connect, ResolveThunks } from "react-redux";

import {
    CallbackType,
    ErrorObjectType,
    InputObjectType,
    validate,
    validateConfirmPasswordHandler,
    validatePasswordHandler,
} from "@tCooneyBrothers/Common/Utilities/validate";
import {
    existingCustomerValidatorConfig,
    FormErrorsStateType,
    intialErrorFormState,
    ValidatorConfigType,
} from "@tCooneyBrothers/Components/CreateAccountExistingFormValidatorConfig";

import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import SignInResetPasswordForm from "@insite/content-library/Widgets/SignIn/SignInResetPasswordForm";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import addAccount from "@tCooneyBrothers/Handlers/AddAccount";

import ReCaptcha from "@tCooneyBrothers/Components/ReCaptcha";
import ReCAPTCHA from "react-google-recaptcha";

export interface CreateAccountExistingFormStyles {
    wrapper?: InjectableCss;
    addressText?: TypographyProps;
    cityStatePostalCodeText?: TypographyProps;
    countryText?: TypographyProps;
    mainGridContainer?: GridContainerProps;
    mainGridItem?: GridItemProps;
    halfGridItem?: GridItemProps;
    userGridItem?: GridItemProps;
    userGridContainer?: GridContainerProps;
    emailGridItem?: GridItemProps;
    emailTextField?: TextFieldPresentationProps;
    userNameGridItem?: GridItemProps;
    userNameTextField?: TextFieldPresentationProps;
    passwordGridItem?: GridItemProps;
    passwordTextField?: TextFieldPresentationProps;
    confirmPasswordTextField?: TextFieldPresentationProps;
    confirmPasswordGridItem?: GridItemProps;
    confirmPasswordIcon?: IconPresentationProps;
    subscriptionGridItem?: GridItemProps;
    submitErrorGridItem?: GridItemProps;
    submitErrorTitle?: TypographyProps;
    submitGridItem?: GridItemProps;
    submitButton?: ButtonPresentationProps;
    centeringWrapper?: InjectableCss;
    requirementsGridItem?: GridItemProps;
    passwordRequirementsGridContainer?: GridContainerProps;
    passwordRequirementsGridItem?: GridItemProps;
    requirementsTitle?: TypographyProps;
    formsTopNav?: InjectableCss;
    passwordIcon?: IconPresentationProps;
    errorColor?: InjectableCss;
    leftPadding?: InjectableCss;
    formWrapper?: InjectableCss;
    existingUser?: InjectableCss;
    marginBottom?: InjectableCss;
    accordionCss?: InjectableCss;
    pdLeftRight?: InjectableCss;
    removePadding?: InjectableCss;
    customInputCss?: InjectableCss;
    inputStyle?: InjectableCss;
    fullWidth?: InjectableCss;
    fiftyPerWidth?: InjectableCss;
    rightPadding?: InjectableCss;
    attributeTypeText?: TypographyPresentationProps;
    linkStyle?: InjectableCss;
    flexStart?: InjectableCss;
    customFlexBox?: InjectableCss;
    customGridOffest?: InjectableCss;
    paddingBottom?: InjectableCss;
    fourtyEightflexWidth?: InjectableCss;
    inlineBlock?: InjectableCss;
    customBlockCss?: InjectableCss;
    errorIndication?: InjectableCss;
    marginTop?: InjectableCss;
    signIn?: InjectableCss;
    departmentSelect: SelectPresentationProps;
    thirtyPerWidth?: InjectableCss;
    seventyPerWidth?: InjectableCss;
    tenPerWidth?: InjectableCss;
    ninetyPerWidth?: InjectableCss;
    centerAlignFlexItems?: InjectableCss;
    sectionHeading?: InjectableCss;
    serverError?: InjectableCss;
    toolTipMessagePassword?: TooltipPresentationProps;
    toolTipMessage?: InjectableCss;
    termsAndConditions?: InjectableCss;
    resetPasswordModal?: ModalPresentationProps;
}

export const CreateAccountExistingFormStyles: CreateAccountExistingFormStyles = {
    wrapper: {
        css: css`
            font-style: normal;
        `,
    },
    addressText: { as: "p" },
    cityStatePostalCodeText: { as: "p" },
    countryText: { as: "p" },
    centeringWrapper: {
        css: css`
            display: flex;
            height: 300px;
            justify-content: center;
            align-items: center;
        `,
    },
    userGridItem: {
        width: [12, 12, 6, 6, 6],
        css: css`
            flex-direction: column;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            padding-left: 100px;
                        `,
                    ],
                    "min",
                )}
        `,
    },
    userGridContainer: {
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            max-width: 300px;
                        `,
                    ],
                    "min",
                )}
        `,
    },
    emailGridItem: {
        width: 12,
    },
    userNameGridItem: {
        width: 12,
    },
    passwordGridItem: {
        width: 12,
    },
    confirmPasswordGridItem: {
        width: 12,
    },
    subscriptionGridItem: {
        width: 12,
    },
    submitErrorGridItem: {
        width: 12,
    },
    submitErrorTitle: {
        color: "danger",
    },
    serverError: {
        css: css`
            background: #f8dcdc;
            color: #db2c2c;
            padding: 10px;
            font-size: 15px;
            display: inline-block;
            button {
                span {
                    color: #db2c2c !important;
                    text-decoration: underline;
                }
            }
        `,
    },
    submitGridItem: {
        width: 12,
        css: css`
            justify-content: flex-end;
        `,
    },
    requirementsGridItem: {
        width: [12, 12, 6, 6, 6],
        css: css`
            flex-direction: column;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            padding-left: 50px;
                        `,
                    ],
                    "min",
                )}/* stylelint-disable-line declaration-block-single-line-max-declarations */
        `,
    },
    passwordRequirementsGridContainer: {
        gap: 5,
    },
    passwordRequirementsGridItem: {
        width: 12,
    },
    requirementsTitle: {
        variant: "h4",
        as: "h2",
    },
    formsTopNav: {
        css: css`
            display: flex;
        `,
    },
    errorColor: {
        css: css`
            color: #ef3742;
        `,
    },
    leftPadding: {
        css: css`
            padding-left: 15px;
        `,
    },
    existingUser: {
        css: css`
            [class^="GridOffset"] {
                width: 100%;
            }
        `,
    },
    formWrapper: {
        css: css`
            // margin-top: 20px;
            margin-bottom: 20px;
            > div[class^="GridWrapper"] {
                // margin-top: 10px;
                // padding-left: 0;
                margin-bottom: 30px;
                // > div[class^="GridOffset"] {
                //     width: 100%;
                //     margin: 0;
                //}
                > div[class^="RadioStyle"] {
                    margin-top: 0;
                    border: 1px solid red;
                    > label[class^="TypographyStyle"] {
                        font-size: 13px;
                    }
                }
            }

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            [data-id="tooltipContainer"] {
                                left: auto !important;
                                right: -12px !important;
                                &:after {
                                    content: "";
                                    left: auto !important;
                                    right: 18px !important;
                                }
                            }
                        `,
                        null,
                        null,
                    ],
                    "max",
                )}
        `,
    },
    marginBottom: {
        css: css`
            margin-bottom: 15px;
            width: 100%;
        `,
    },
    accordionCss: {
        css: css`
            background-color: #efefef;
        `,
    },
    pdLeftRight: {
        css: css`
            padding-left: 15px;
            padding-right: 15px;
        `,
    },
    removePadding: {
        css: css`
            padding-left: 0;
        `,
    },
    customInputCss: {
        css: css`
            width: calc(33.3333% - 20px);
            display: inline-block;
            vertical-align: top;
            margin-bottom: 20px;
            margin-right: 30px;
            &:nth-child(3n + 1) {
                margin-right: 0;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            width: 100%;
                            margin-right: 0;
                        `,
                    ],
                    "max",
                )}

            > div[class^="FormFieldStyle"] {
                position: relative;
                width: 90%;
                > label {
                    font-size: 13px;
                    position: absolute;
                    z-index: 1;
                    padding-left: 5px;
                    background-color: #fff;
                    display: inline-block;
                    width: auto;
                    left: 20px;
                }
                > div input[type="text"] {
                    font-size: 13px;
                }
                > div select {
                    font-size: 13px;
                }
                > div[class^="FormInputWrapper"] {
                    > input {
                        font-size: 13px;
                    }
                    > div {
                        > span {
                            font-size: 13px;
                        }
                    }
                }
            }
            > div[class^="TooltipWrapper"] {
                width: 10%;
                padding: 10px;
            }
        `,
    },

    inputStyle: {
        css: css`
            width: 100%;

            input::-webkit-outer-spin-button,
            input::-webkit-inner-spin-button {
                -webkit-appearance: none;
                margin: 0;
            }

            /* Firefox */
            input[type="number"] {
                -moz-appearance: textfield;
            }

            input[type="number"] {
                appearance: none;
                -webkit-appearance: none;
                -moz-appearance: none;
            }

            > div[class^="FormFieldStyle"] {
                position: relative;
                width: 90%;
                > label {
                    font-size: 13px;
                    position: absolute;
                    z-index: 1;
                    padding-left: 5px;
                    background-color: #fff;
                    display: inline-block;
                    width: auto;
                    left: 20px;
                }
                > div input[type="text"] {
                    font-size: 13px;
                }
                > div select {
                    font-size: 13px;
                }
                > div[class^="FormInputWrapper"] {
                    > input {
                        font-size: 13px;
                    }
                    > div {
                        > span {
                            font-size: 13px;
                        }
                    }
                }
            }
            > div[class^="TooltipWrapper"] {
                width: 10%;
                padding: 10px;
            }
        `,
    },

    fullWidth: {
        css: css`
            width: 100%;
            > div[class^="RadioGroupStyle"] {
                justify-content: flex-start;
                display: inline-block;
                > div[class^="RadioStyle"] {
                    margin-top: 0;
                    margin-right: 20px;
                    display: inline-block;
                    &:last-child {
                        margin-right: 0;
                    }
                    > label[class^="TypographyStyle"] {
                        font-size: 13px;
                    }
                }
            }
        `,
    },
    fiftyPerWidth: {
        css: css`
            width: 50%;
        `,
    },
    rightPadding: {
        css: css`
            padding-right: 15px;
        `,
    },
    linkStyle: {
        css: css`
            & span {
                color: #f03742 !important;
                text-decoration: underline;
            }
        `,
    },
    flexStart: {
        css: css`
            justify-content: flex-start;
        `,
    },
    customFlexBox: {
        css: css`
            display: flex;
            justify-content: space-between;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            flex-direction: column;
                        `,
                    ],
                    "max",
                )}
        `,
    },
    customGridOffest: {
        css: css`
            > div[class^="GridOffset"] {
                margin: 0;
                width: 100%;
            }
        `,
    },
    departmentSelect: {
        labelProps: {
            css: css`
                width: 100%;
            `,
        },
        cssOverrides: {
            formField: css`
                width: 100%;
            `,
        },
    },
    paddingBottom: {
        css: css`
            padding-bottom: 15px;
        `,
    },
    fourtyEightflexWidth: {
        css: css`
            width: 48%;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            width: 100%;
                        `,
                    ],
                    "max",
                )}
        `,
    },
    inlineBlock: {
        css: css`
            display: inline-block;
            vertical-align: top;
        `,
    },
    customBlockCss: {
        css: css`
            display: block;
        `,
    },
    errorIndication: {
        css: css`
            font-size: 12px;
            margin-top: 10px;
        `,
    },
    marginTop: {
        css: css`
            margin-top: 15px;
        `,
    },
    signIn: {
        css: css`
            div[data-test-selector="createAccount_Subscription"] {
                > label {
                    font-size: 13px;
                }
            }
        `,
    },
    thirtyPerWidth: {
        css: css`
            width: 30%;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            width: 100%;
                        `,
                    ],
                    "max",
                )}
        `,
    },
    seventyPerWidth: {
        css: css`
            width: 70%;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            width: 100%;
                        `,
                    ],
                    "max",
                )}
        `,
    },
    tenPerWidth: {
        css: css`
            width: 10%;
        `,
    },
    ninetyPerWidth: {
        css: css`
            width: 90%;
        `,
    },
    centerAlignFlexItems: {
        css: css`
            align-items: center;
        `,
    },
    sectionHeading: {
        css: css`
            font-weight: bold;
            border-bottom: 2px solid #ef3742;
            padding: 9px;
            padding-left: 15px;
            width: 100%;
            background: #f8f9fa;
            margin-bottom: 25px;
            margin-top: 25px;
        `,
    },

    toolTipMessage: {
        css: css`
            color: white;
            z-index: 2;

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            left: auto !important;
                            right: -5px !important;
                            &:after {
                                content: "";
                                left: auto !important;
                                right: 11px !important;
                            }
                        `,
                        null,
                        null,
                    ],
                    "max",
                )}
        `,
    },
    toolTipMessagePassword: {
        css: css`
            color: white;
            z-index: 2;

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            left: auto !important;
                            right: -5px !important;
                            &:after {
                                content: "";
                                left: auto !important;
                                right: 11px !important;
                            }
                        `,
                        null,
                        null,
                    ],
                    "max",
                )}
        `,
        typographyProps: {
            css: css`
                text-align: left;
            `,
        },
    } as TooltipPresentationProps,
    termsAndConditions: {
        css: css`
            font-size: 13px;
            margin-top: 15px;
        `,
    },
    mainGridItem: {
        width: [11, 11, 11, 9, 9],
        css: css`
            display: block;
            padding: 0;
            margin-bottom: 20px !important;
        `,
    },
    halfGridItem: {
        width: [12, 12, 6, 6, 6],
        css: css`
            [data-test-selector="createAccount_password"] {
                width: 100%;
                white-space: nowrap;
                text-overflow: ellipsis;
                padding-right: 35px !important;
            }
            [data-test-selector="createAccount_confirmPassword"] {
                width: 100%;
                white-space: nowrap;
                text-overflow: ellipsis;
                padding-right: 35px !important;
            }
        `,
    },
    resetPasswordModal: {
        sizeVariant: "small",
    },
};
const StyledSpan = getStyledWrapper("span");

const StyledForm = getStyledWrapper("form");
interface OwnProps {
    extendedStyles?: CreateAccountExistingFormStyles;
    retrunUrl?: any;
    departments?: DepartmentModel[];
    validateReCaptcha?: any;
}

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const mapDispatchToProps = {
    addAccount,
    signIn,
    validatePassword,
};



const mapStateToProps = (state: ApplicationState) => ({
    accountSettings: getSettingsCollection(state).accountSettings,
    returnUrl: getCreateAccountReturnUrl(state)
});

const emailRegexp = new RegExp("\\w+([-+.']\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*");

const CreateAccountExistingForm: React.FunctionComponent<Props> = function Account(props: Props) {
    const depWithOther = props?.departments && props?.departments.filter(a => a.description === "Other");
    const depWithoutOther = props?.departments && props?.departments.filter(a => a.description !== "Other");
    const department = depWithoutOther && depWithOther && depWithoutOther.push(depWithOther[0]);
    
    const firstNameErrorMsg = siteMessage("createAccountInfo_FirstNameRequired");
    const lastNameErrorMsg = siteMessage("createAccountInfo_LastNameRequired");
    const emailRequiredFieldMessage = siteMessage("createAccountInfo_Email_Required");
    const emailFieldMessage = siteMessage("CreateNewAccountInfo_EmailAddress_ValidEmail");
    const phoneErrorMsg = siteMessage("createAccountInfo_PhoneNoRequired");
    const validPhoneMsg = siteMessage("createAccountInfo_PhoneNoValidation");
    const passwordErrorMsg = siteMessage("createAccountInfo_PasswordRequired");
    const confirmPasswordErrorMsg = siteMessage("createAccountInfo_PasswordConfirmationRequired");
    const accountNumberErrorMsg = siteMessage("createAccountInfo_AccountNumberRequired");

    const [depState, setDepState] = React.useState(depWithoutOther && depWithoutOther[0]);
    const [returnUrl, setReturnUrl] = React.useState(props.returnUrl);
    const [styles] = React.useState(() => mergeToNew(CreateAccountExistingFormStyles, props.extendedStyles));
    const [email, setEmail] = React.useState("");
    const [userName, setUserName] = React.useState(email);
    const [password, setPassword] = React.useState("");
    const [confirmPassword, setConfirmPassword] = React.useState("");
    const [isSubmitted, setIsSubmitted] = React.useState(false);
    const [showPassword, setShowPassword] = React.useState(false);
    const [confirmPasswordErrorMessage, setConfirmPasswordErrorMessage] = React.useState<React.ReactNode>("");
    const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);
    const [passwordErrorMessage, setPasswordErrorMessage] = React.useState<React.ReactNode>("");
    // const [isSubscribed, setIsSubscribed] = React.useState(true);
    const [errorMessage, setErrorMessage] = React.useState("");
    const toasterContext = React.useContext(ToasterContext);
    const [firstName, setFirstName] = React.useState("");
    const [firstNameError, setFirstNameError] = useState(firstNameErrorMsg);
    const [lastName, setLastName] = React.useState("");
    const [lastNameError, setLastNameError] = useState(lastNameErrorMsg);
    const [emailError, setEmailError] = useState(emailRequiredFieldMessage);
    const [phone, setPhone] = React.useState("");
    const [phoneError, setPhoneError] = useState(phoneErrorMsg);
    const [customerNumberProvided, setCustomerNumberProvided] = React.useState(true);
    const [accountNumberErrorMessage, setAccountNumberErrorMessage] = React.useState(accountNumberErrorMsg);
    const [accountNumber, setAccountNumber] = React.useState("");
    const [formErrors, setFormErrors] = React.useState<FormErrorsStateType>(intialErrorFormState);
    const [showExistEmail, setshowExistEmail] = React.useState(false);
    const [isResetPasswordModalOpen, setIsResetPasswordModalOpen] = React.useState(false);
    const [showLoadingState, setLoadingState] = React.useState(false);
    const FormRef = useRef<HTMLFormElement>(null);

    const {validateReCaptcha} = props;
    const recaptchaRef: RefObject<ReCAPTCHA> = React.createRef();

    const validateEmail = (email: string) => {
        const errorMessage = !email ? emailRequiredFieldMessage : emailRegexp.test(email) ? "" : emailFieldMessage;
        setEmailError(errorMessage);
        return !errorMessage;
    };

    const validateConfirmPassword = (newPassword: string, newConfirmPassword: string) => {
        const errorMessage =
            newPassword !== newConfirmPassword
                ? siteMessage("CreateNewAccountInfo_PasswordCombination_DoesNotMatch")
                : "";
        setConfirmPasswordErrorMessage(errorMessage);
        return !errorMessage;
    };
 
    const validateSubmitEnabled = () => {
        return !(
            emailError ||
            passwordErrorMessage ||
            accountNumberErrorMessage ||
            firstNameError ||
            lastNameError ||
            phoneError ||
            confirmPasswordErrorMessage
        );
    };

    const emailChangeHandler = (input: HTMLInputElement) => {
        validateEmail(input.value);
        setEmail(input.value);
        setUserName(input.value);
    };

    const passwordChangeHandler = (input: HTMLInputElement) => {
        validateConfirmPassword(input.value, confirmPassword);
        validatePassword({
            password: input.value,
            onComplete: errorMessage => {
                setPasswordErrorMessage(errorMessage);
            },
        });
        setPassword(input.value);
        pwdHandler(input);
    };

    const confirmPasswordChangeHandler = (input: HTMLInputElement) => {
        setConfirmPassword(input.value);
        validateConfirmPassword(password, input.value);
        pwdHandler(input);
    };
    const returnUrlChangeHandler = (returnUrl: string) => {
        setReturnUrl(returnUrl);
    };
    const onBlurValidationHandler = (input: HTMLInputElement | HTMLSelectElement) => {
        validateHandler(input);
    };

    const scrollToFirstFormError = () => {
        const firstErrorElement = document.querySelector("[aria-invalid='true']");
        if (firstErrorElement) {
            const formFieldParent = firstErrorElement.closest("[class*='FormFieldStyle']");
            if (!formFieldParent) {
                return;
            }
            const { top } = formFieldParent.getBoundingClientRect();
            formFieldParent.scrollIntoView({
                behavior: "smooth",
                block: "center",
            });
        }
    };

    const submitHandler = async (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();

        const isCaptchaValid = await validateReCaptcha({ location: "ContactUs", recaptchaRef });
        if (!isCaptchaValid) {
            return;
        }

        if (!isSubmitted) {
            setIsSubmitted(true);
        }
        // setLoadingState(true);
        if (!validateSubmitEnabled()) {
            setFormErrors(formErrors);
            setTimeout(() => {
                scrollToFirstFormError();
            }, 50);
            return;
        }

        const selectedDept = depState && depState.description;

        props.addAccount({
            email,
            userName,
            accountNumber,
            firstName,
            lastName,
            phone,
            password,
            IsCustomerNumberProvided: customerNumberProvided,
            companyName: "",
            address1: "",
            address2: "",
            city: "",
            postalCode: "",
            IsShipToSameAsBilling: false,
            companyNameShipTo: "",
            address1ShipTo: "",
            address2ShipTo: "",
            cityShipTo: "",
            zipShipTo: "",
            IsCreditAccount: false,
            businessStartDate: "",
            organizationStructure: "",
            stateDateIncorporated: "",
            companyOperationalTime: "",
            principalActivity: "",
            IsCompanyNameChanged: "",
            formerName: "",
            IsPastBought: "",
            pastBuyerName: "",
            creditLimit: "",
            IsSalesTaxExempt: "",
            apContact: "",
            apContactEmail: "",
            bankName: "",
            bankAccount: "",
            bankAddress: "",
            bankPhone: "",
            bankFax: "",
            businessRefCompName1: "",
            businessRefName1: "",
            businessRefTitle1: "",
            businessRefAddress1: "",
            businessRefPhone1: "",
            businessRefFax1: "",
            businessRefCompName2: "",
            businessRefName2: "",
            businessRefTitle2: "",
            businessRefAddress2: "",
            businessRefPhone2: "",
            businessRefFax2: "",
            IsBankrupt: "",
            IsSuitFiled: "",
            IsUpsAccount: "",
            upsAccount: "",
            receivingHours: "",
            IsTerms: "",
            invEmailText: "",
            invFaxNumberText: "",
            suitFiledText: "",
            IsBankruptText: "",
            selectedDept,
            selectedCountry: "",
            selectedbtState: "",
            selectedStCountry: "",
            selectedStState: "",
            phoneShipTo: "",
            onSuccess: onSuccessHandler,
            onError: (error: any, statusCode) => {
                const errorNumber = error.split(", Message: ")[0].split("Error Code: ")[1];
                const errorMessage = error.split("Message: ")[1];
                setLoadingState(false);

                if (errorNumber === "533") {
                    setshowExistEmail(true);
                    setErrorMessage("");
                    setLoadingState(false);
                } else if (statusCode === 404) {
                    setshowExistEmail(false);
                    error = siteMessageWithCustomParserOptions(
                        "UserRegistration_AccountNumberDoesNotExists",
                        parserOptions,
                    );
                    setErrorMessage(error);
                } else {
                    setshowExistEmail(false);
                    setErrorMessage(error);
                }
            },
            isSubscribed: false,
        });
    };

    const onSuccessHandler = () => {
        setErrorMessage("");
        toasterContext.addToast({
            body: translate("Account created successfully!"),
            messageType: "success",
        });
        setTimeout(() => {
            props.signIn({
                userName,
                password,
                rememberMe: false,
                returnUrl,
            });
        }, 500);
        const dataLayer = (window as any).dataLayer || [];
        if (dataLayer) {
            dataLayer.push({ ecommerce: null });
            dataLayer.push({
                event: "sign_up",
                registration_type: "Existing Customer Account",
            });
        }
    };

    const accountNumberChangeHandler = (input: HTMLInputElement) => {
        setAccountNumber(input.value);
        validateAccountNumber(input);
    };

    const validateAccountNumber = (accountNumber: HTMLInputElement) => {
        const errorMessage = !accountNumber ? accountNumberErrorMsg : "";
        setAccountNumberErrorMessage(errorMessage);
        return !errorMessage;
    };

    const firstNameHandler = (input: HTMLInputElement) => {
        validateFirstName(input.value);
        setFirstName(input.value);
    };
    const validateFirstName = (name: string) => {
        const errorMessage = !name ? firstNameErrorMsg : "";
        setFirstNameError(errorMessage);
        return !errorMessage;
    };
    const lastNameHandler = (name: string) => {
        validateLastName(name);
        setLastName(name);
    };

    const validateLastName = (name: string) => {
        const errorMessage = !name ? lastNameErrorMsg : "";
        setLastNameError(errorMessage);
        return !errorMessage;
    };

    const validatePhone = (value: string) => {
        const errorMessage = !value || value.length <= 11 ? validPhoneMsg : "";
        setPhoneError(errorMessage);
        return !errorMessage;
    };

    const phoneChangeHandler = (value: string) => {
        setPhone(formatPhoneNumber(value));
        validatePhone(value);
    };

    const handleDepartmentChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedDepartment = props.departments!.find(c => c.id === event.currentTarget.value)!;
        setDepState(selectedDepartment);
    };

    const validateSubmitDisabled = (errorsState: FormErrorsStateType) => {
        return Object.keys(errorsState).length !== 0;
    };

    const validateHandler = (input: HTMLInputElement | HTMLSelectElement, customValidation?: CallbackType): void => {
        const inputObject: InputObjectType = {
            name: input.name,
            value: input.value,
        };
        const validatorConfig = existingCustomerValidatorConfig[input.name as keyof ValidatorConfigType];
        const isValidate: ErrorObjectType | undefined = validate(inputObject, validatorConfig, customValidation);

        if (isValidate === undefined) {
            delete formErrors[input.name as keyof FormErrorsStateType];
            setFormErrors(removeKey(formErrors, input.name));
        } else {
            setFormErrors({
                ...formErrors,
                [input.name]: isValidate ? isValidate.errorMsg : isValidate,
            });
        }
        if (!validatorConfig.required && input.value === "") {
            delete formErrors[input.name as keyof FormErrorsStateType];
            setFormErrors(formErrors);
        }
    };
    const removeKey = (formErrorObject: FormErrorsStateType, deleteKey: string) => {
        return Object.assign(
            {},
            ...Object.entries(formErrorObject)
                .filter(([k]) => k !== deleteKey)
                .map(([k, v]) => ({ [k]: v })),
        );
    };

    const pwdHandler = (input: HTMLInputElement) => {
        const pwd = input.name === "password" ? input.value : password;
        const confirmPwd = input.name === "confirmPassword" ? input.value : confirmPassword;

        const isValidate: ErrorObjectType | undefined =
            input.name === "password"
                ? validatePasswordHandler(pwd, confirmPwd, props.accountSettings)
                : validateConfirmPasswordHandler(pwd, confirmPwd);
        if (isValidate === undefined) {
            delete formErrors[input.name as keyof FormErrorsStateType];
            setFormErrors(formErrors);
        } else {
            setFormErrors({
                ...formErrors,
                [input.name]: isValidate ? isValidate.errorMsg : isValidate,
            });
        }
    };

    const onResetPasswordClose = () => {
        setIsResetPasswordModalOpen(false);
    };
    const handleClicktoManageErrorMessage = () => {
        document.getElementById("createAccountExsitingForm")?.click();
    };

    return (
        <StyledForm
            id="createAccountExsitingForm"
            noValidate={true}
            ref={FormRef}
            onSubmit={handleClicktoManageErrorMessage}
        >
            <LoadingOverlay loading={showLoadingState} spinnerProps={{ color: "primary" }}>
                <StyledWrapper /* {...styles.formWrapper}>
            <Typography as="p">
                I am an existing customer and know my Cooney Brothers account number. I am requesting login credentials
                to purchase online.
            </Typography */
                    {...styles.existingUser}
                >
                    <Typography as="p" {...styles.errorIndication}>
                        <StyledSpan {...styles.errorColor}>*</StyledSpan> Indicates a required field
                    </Typography>
                    <form autoComplete="off">
                        <GridContainer {...styles.mainGridContainer} {...styles.leftPadding}>
                            <GridItem {...styles.mainGridItem}>
                                <StyledWrapper {...styles.sectionHeading}>Existing Customer Registration</StyledWrapper>
                                <GridContainer>
                                    <GridItem {...styles.halfGridItem}>
                                        <StyledWrapper {...CreateAccountExistingFormStyles.inputStyle}>
                                            <TextField
                                                {...styles.userNameTextField}
                                                type="number"
                                                label={translate("Account Number")}
                                                value={accountNumber}
                                                data-test-selector="createAccount_accountNumber"
                                                onChange={e => accountNumberChangeHandler(e.currentTarget)}
                                                error={isSubmitted && accountNumberErrorMessage}
                                                name="accountNumber"
                                                iconProps={{
                                                    color: "danger",
                                                    src: formErrors.accountNumber ? AlertTriangle : undefined,
                                                }}
                                                required
                                            />
                                            <Tooltip
                                                {...styles.toolTipMessage}
                                                text={
                                                    siteMessage(
                                                        "Your Cooney Brothers account number. Your address and order history will be automatically pulled from our system by your account number. Not sure what it is? Call us at 610.272.2100.",
                                                    ) as string
                                                }
                                            />
                                        </StyledWrapper>

                                        {/* <StyledWrapper {...CreateAccountExistingFormStyles.customInputCss}>
                    <Typography {...styles.attributeTypeText} {...styles.errorIndication}>
                        Your Cooney Brothers account number. Your address and order history will be automatically pulled from our system by your account number. Not sure what it is? Call us at 610.272.2100.
                    </Typography>
                </StyledWrapper> */}
                                    </GridItem>
                                    <GridItem {...styles.halfGridItem}>
                                        <StyledWrapper {...CreateAccountExistingFormStyles.inputStyle}>
                                            <Select
                                                {...styles.departmentSelect}
                                                label={translate("Department")}
                                                value={
                                                    (depState && depState.id) ||
                                                    (props.departments && props.departments[0].id)
                                                }
                                                labelPosition="top"
                                                onChange={e => handleDepartmentChange(e)}
                                            >
                                                {depWithoutOther &&
                                                    depWithoutOther.map(dept => (
                                                        <option key={dept?.id} value={dept?.id}>
                                                            {dept?.description}
                                                        </option>
                                                    ))}
                                            </Select>
                                            <Tooltip
                                                {...styles.toolTipMessage}
                                                text={
                                                    siteMessage(
                                                        "Choose a department from the list that best describes your role within the company",
                                                    ) as string
                                                }
                                            />
                                        </StyledWrapper>
                                    </GridItem>
                                    <GridItem {...styles.halfGridItem}>
                                        <StyledWrapper {...styles.inputStyle}>
                                            <TextField
                                                {...styles.userNameTextField}
                                                label={translate("First Name")}
                                                value={firstName}
                                                data-test-selector="createAccount_firstName"
                                                onChange={e => firstNameHandler(e.currentTarget)}
                                                error={isSubmitted && firstNameError}
                                                name="firstName"
                                                iconProps={{
                                                    color: "danger",
                                                    src: formErrors.firstName ? AlertTriangle : undefined,
                                                }}
                                                required
                                            />
                                        </StyledWrapper>
                                    </GridItem>
                                    <GridItem {...styles.halfGridItem}>
                                        <StyledWrapper {...styles.inputStyle}>
                                            <TextField
                                                {...styles.userNameTextField}
                                                label={translate("Last Name")}
                                                value={lastName}
                                                data-test-selector="createAccount_lastName"
                                                onChange={e => lastNameHandler(e.currentTarget.value)}
                                                error={isSubmitted && lastNameError}
                                                name="lastName"
                                                iconProps={{
                                                    color: "danger",
                                                    src: formErrors.lastName ? AlertTriangle : undefined,
                                                }}
                                                required
                                            />
                                        </StyledWrapper>
                                    </GridItem>
                                    <GridItem {...styles.halfGridItem}>
                                        <StyledWrapper {...styles.inputStyle}>
                                            <TextField
                                                {...styles.emailTextField}
                                                type="email"
                                                label={translate("User Name (Email Address)")}
                                                onChange={e => emailChangeHandler(e.currentTarget)}
                                                value={email}
                                                data-test-selector="createAccount_email"
                                                required
                                                error={isSubmitted && emailError}
                                                name="email"
                                                iconProps={{
                                                    color: "danger",
                                                    src: formErrors.email ? AlertTriangle : undefined,
                                                }}
                                            />
                                            <Tooltip
                                                {...styles.toolTipMessage}
                                                text={
                                                    siteMessage(
                                                        "Your E-Mail Address will serve as your User ID when you Login",
                                                    ) as string
                                                }
                                            />
                                        </StyledWrapper>
                                    </GridItem>
                                    <GridItem {...styles.halfGridItem}>
                                        <StyledWrapper {...styles.inputStyle}>
                                            <TextField
                                                {...styles.userNameTextField}
                                                type="tel"
                                                autoComplete="autocomplete_off_randString"
                                                label={translate("Phone Number")}
                                                value={phone}
                                                data-test-selector="createAccount_phone"
                                                onChange={e => phoneChangeHandler(e.currentTarget.value)}
                                                error={isSubmitted && phoneError}
                                                name="phone"
                                                iconProps={{
                                                    color: "danger",
                                                    src: formErrors.phone ? AlertTriangle : undefined,
                                                }}
                                                required
                                            />
                                            <Tooltip
                                                {...styles.toolTipMessage}
                                                text={
                                                    siteMessage(
                                                        "Best phone number to reach you for business-related questions. Please enter only numbers. No dashes '-' or other characters are accepted.",
                                                    ) as string
                                                }
                                            />
                                        </StyledWrapper>
                                    </GridItem>
                                    <GridItem {...styles.halfGridItem}>
                                        <StyledWrapper {...styles.inputStyle}>
                                            <TextField
                                                id="password"
                                                {...styles.passwordTextField}
                                                type={showPassword ? undefined : "password"}
                                                label={translate("Password")}
                                                value={password}
                                                onChange={e => passwordChangeHandler(e.currentTarget)}
                                                iconProps={{ ...styles.passwordIcon, src: showPassword ? EyeOff : Eye }}
                                                iconClickableProps={{
                                                    onClick: (e: any) => {
                                                        e.preventDefault();
                                                        setShowPassword(!showPassword);
                                                    },
                                                }}
                                                data-test-selector="createAccount_password"
                                                error={
                                                    isSubmitted && password === ""
                                                        ? passwordErrorMsg
                                                        : formErrors.password
                                                }
                                                name="password"
                                                required
                                            />
                                            <Tooltip
                                                {...styles.toolTipMessagePassword}
                                                text={
                                                    siteMessage(
                                                        'Password must be at least 8 characters long and include : <br/> - an uppercase character <br/> - a lowercase character <br/> - a number <br/> - a non-alphanumeric character (but not "%", "?", "&" or ":") ',
                                                    ) as string
                                                }
                                            />
                                        </StyledWrapper>
                                    </GridItem>
                                    <GridItem {...styles.halfGridItem}>
                                        <StyledWrapper {...styles.inputStyle}>
                                            <TextField
                                                id="confirm-password"
                                                {...styles.confirmPasswordTextField}
                                                type={showConfirmPassword ? undefined : "password"}
                                                label={translate("Confirm Password")}
                                                value={confirmPassword}
                                                onChange={e => confirmPasswordChangeHandler(e.currentTarget)}
                                                iconProps={{
                                                    ...styles.confirmPasswordIcon,
                                                    src: showConfirmPassword ? EyeOff : Eye,
                                                }}
                                                iconClickableProps={{
                                                    onClick: (e: any) => {
                                                        e.preventDefault();
                                                        setShowConfirmPassword(!showConfirmPassword);
                                                    },
                                                }}
                                                data-test-selector="createAccount_confirmPassword"
                                                name="confirmPassword"
                                                error={
                                                    isSubmitted && confirmPassword === ""
                                                        ? confirmPasswordErrorMsg
                                                        : formErrors.confirmPassword
                                                }
                                                required
                                            />
                                        </StyledWrapper>
                                    </GridItem>
                                </GridContainer>
                            </GridItem>
                        </GridContainer>
                    </form>
                    {/* <StyledWrapper {...styles.marginBottom}>
                        <CheckboxGroup {...styles.signIn}>
                            <Checkbox
                                onChange={(e, value) => setIsSubscribed(value)}
                                checked={isSubscribed}
                                data-test-selector="createAccount_Subscription"
                            >
                                {siteMessage("SignIn_Sign_Up_Newsletter")}
                            </Checkbox>
                        </CheckboxGroup>
                    </StyledWrapper> */}
                    <StyledWrapper {...styles.marginTop}>
                        {errorMessage && (
                            <GridItem {...styles.submitErrorGridItem}>
                                <Typography {...styles.serverError}>{errorMessage}</Typography>
                            </GridItem>
                        )}
                        {showExistEmail && (
                            <>
                                <Typography {...CreateAccountExistingFormStyles.serverError}>
                                    Email Address already exists. Please{" "}
                                    <Link type="button" onClick={() => setIsResetPasswordModalOpen(true)}>
                                        click here
                                    </Link>{" "}
                                    to reset your password.
                                </Typography>
                                <Modal
                                    headline={translate("Reset Password")}
                                    {...styles.resetPasswordModal}
                                    isOpen={isResetPasswordModalOpen}
                                    handleClose={() => onResetPasswordClose()}
                                >
                                    <SignInResetPasswordForm onClose={() => onResetPasswordClose()} />
                                </Modal>
                            </>
                        )}
                    </StyledWrapper>
                    <ReCaptcha recaptchaRef={recaptchaRef} location="ContactUs" />
                    <StyledWrapper
                        {...styles.submitGridItem}
                        {...styles.flexStart}
                        {...styles.marginBottom}
                        {...styles.marginTop}
                    >
                        <Button
                            {...styles.submitButton}
                            onClick={submitHandler}
                            data-test-selector="createAccount_createButton"
                        >
                            {translate("Register Now")}
                        </Button>
                    </StyledWrapper>
                    <Typography as="p" {...styles.termsAndConditions}>
                        By clicking the "Register Now" button, you agree to Cooney Brothers{" "}
                        <Link {...styles.linkStyle} href="/TermsandConditions" target="_blank">
                            Terms and Conditions
                        </Link>
                    </Typography>
                </StyledWrapper>
            </LoadingOverlay>
            <button onClick={submitHandler} type="submit" style={{ display: "none" }}>
                {translate("Register Now")}
            </button>
        </StyledForm>
    );
};

export default CreateAccountExistingForm;
